import $assets from '@/assets';

// const socketServer = process.env.VUE_APP_SOCKET_SERVER || window.location.origin;
// const socketPath = process.env.VUE_APP_SOCKET_PATH;
// const socketUrl = socketServer + socketPath;

// const gateServer = process.env.VUE_APP_GATE_SERVER || window.location.origin;
// const gatePath = process.env.VUE_APP_GATE_PATH;
// const gateUrl = gateServer + gatePath;

// export default {
//   resolve(server) {
//     const paths = {};

//     switch (server) {
//       case 'socket':
//         paths.server = socketServer;
//         paths.path = socketPath;
//         paths.url = socketUrl.replace(/\/$/, '');
//         break;
//       case 'gate':
//         paths.server = gateServer;
//         paths.path = gatePath;
//         paths.url = gateUrl.replace(/\/$/, '');
//         break;
//       default:
//         paths.server = appServer;
//         paths.path = appPath;
//         paths.url = appUrl.replace(/\/$/, '');
//     }

//     return paths;
//   },
// };

export default {
  resolveApp() {
    const appServer = window.location.origin;
    const appPath = process.env.VUE_APP_PATH;
    const appUrl = appServer + appPath;

    return appUrl.replace(/\/+$/, '');
  },

  resolveGate(module) {
    const gateServer = process.env.VUE_APP_GATE_SERVER || window.location.origin;
    const gatePath = process.env.VUE_APP_GATE_PATH;
    const gateUrl = gateServer + gatePath;

    return `${gateUrl.replace(/\/+$/, '')}/${module.replace(/^\/+/, '')}`;
  },

  resolveAPI(api, crossDomain) {
    if (!api) return null;

    const apiServer = process.env.VUE_APP_API_SERVER || window.location.origin;
    const apiPath = process.env.VUE_APP_API_PATH;
    const apiUrl = apiServer + apiPath;

    return crossDomain
      ? `${apiUrl.replace(/\/+$/, '')}/${api}`
      : `${apiPath.replace(/\/+$/, '')}/${api.replace(/^\/+/, '')}`;
  },

  resolveSocket() {
    const socketServer = process.env.VUE_APP_SOCKET_SERVER || window.location.origin;
    const socketPath = `${process.env.VUE_APP_SOCKET_PATH.replace(/\/+$/, '')}/socket.io`;

    return { server: socketServer, path: socketPath };
  },

  resolveImage(image, defaultImage) {
    if (!image) return defaultImage || $assets.svg.hub_spacer;

    const imageServer = process.env.VUE_APP_RESOURCE_SERVER || window.location.origin;
    const imagePath = process.env.VUE_APP_RESOURCE_PATH;
    const imageUrl = imageServer + imagePath;

    return `${imageUrl.replace(/\/+$/, '')}/${image.replace(/^\/+/, '')}`;
  },

  resolveFile(file) {
    if (!file) return null;

    const resourceServer = process.env.VUE_APP_RESOURCE_SERVER || window.location.origin;
    const resourcePath = process.env.VUE_APP_RESOURCE_PATH;
    const resourceUrl = resourceServer + resourcePath;

    return `${resourceUrl.replace(/\/+$/, '')}/${file.replace(/^\/+/, '')}`;
  },

  resolve(image, defaultImage) {
    if (!image) return defaultImage || $assets.svg.hub_spacer;
    return image;
  },
};
